<p>adc-dashboard works!</p>
